var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIllustartion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#fff",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "4rem",
    width: "4rem",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21h-6.426a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304h11.339a2 2 0 0 1 1.977 2.304l-.258 1.678"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11v-5a3 3 0 0 1 6 0v5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22v.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIllustartion);
export default __webpack_public_path__ + "static/media/cartIllustartion.81dcd38f402be56831351b8186e9e38a.svg";
export { ForwardRef as ReactComponent };